import React from 'react';
import Slider from 'react-slick';
import '../../../../styles/CabRoute.css';
import { setDateAsTommorrow } from '../../../../../src/utils/dateTimeFormatUtils';
import queryString from 'query-string';
import PropTypes from 'prop-types';
const isSSR = () => typeof window === 'undefined';

const CabRoute = ({ data }) => {
  const calculateDiscount = (oldPrice, newPrice) => {
    const oldPriceInNumber = Number(oldPrice.replace(',', ''));
    const newPriceInNumber = Number(newPrice.replace(',', ''));
    return `${Math.round(((oldPriceInNumber - newPriceInNumber) / oldPriceInNumber) * 100)}% off`;
  };

  const getRedirectionUrl = (url) => {
    const query = queryString.parseUrl(url).query;
    const fromCity = query['fromCity'];
    const toCity = query['toCity'];
    const redirectionUrl =
      !isSSR() && window['mmt_android_bridge'] && window['mmt_android_bridge']['openDeeplink']
        ? `${setDateAsTommorrow(
            `mmyt://react/?page=cabsListing&deeplink=true&to=${toCity}&from=${fromCity}&tripType=OW&startDate=21-08-2020`
          )}`
        : `${setDateAsTommorrow(url)}`;
    window.location = Object(redirectionUrl);
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4.3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2.8,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2.3,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1.8,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <Slider {...settings}>
      {data &&
        data.length > 0 &&
        data.map(({ id, title, pricePerKm, cabImg, oldPrice, newPrice, cabName, cta, url }) => (
          <div key={id} className="rlCabItem">
            {title && <p className="font14 latoBold appendBottom12 blackText">{title}</p>}
            <div className="rlCabItem__desc">
              {pricePerKm && <span className="rlCabItem__tag">₹{pricePerKm}</span>}
              {cabImg && (
                <span className="rlCabItem__img">
                  <div className={cabImg} />
                </span>
              )}
              <div className="rlCabItem__dtl">
                {oldPrice && (
                  <p className="font10 greyText">
                    <span className="lineThrough">₹{oldPrice}</span>
                  </p>
                )}
                {newPrice && (
                  <p className="makeFlex hrtlCenter">
                    <span className="font16 blackText">₹{newPrice}</span>{' '}
                    {oldPrice && newPrice && (
                      <span className="font12 redText appendLeft5">{calculateDiscount(oldPrice, newPrice)}</span>
                    )}
                  </p>
                )}
                {cabName && <p className="latoBlack font14 appendTop3">{cabName}</p>}
                {cta && (
                  <p className="appendTop8">
                    <a
                      href={url}
                      className="capText latoBlack font12"
                      onClick={(e) => {
                        e.preventDefault();
                        getRedirectionUrl(url);
                      }}
                    >
                      {cta}
                    </a>
                  </p>
                )}
              </div>
            </div>
          </div>
        ))}
    </Slider>
  );
};

CabRoute.propTypes = {
  data: PropTypes.array
};

export default CabRoute;
